// src/components/settings/UserFormModal.jsx
import React from "react";
import "../../assets/styles/common.css";
import "./Settings.css"; // Keep this for specific settings tab styles

const UserFormModal = ({
  showModal,
  editingUser,
  tempUser,
  handleChange,
  handleSaveUser,
  onClose, // Renamed from setShowModal(false) for clarity in child component
}) => {
  if (!showModal) return null; // Don't render if not visible

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{editingUser ? "Edit User" : "Add New User"}</h3>
        <form onSubmit={handleSaveUser} className="modal-form">
          <div className="form-group">
            <label>Username:</label>
            <input
              type="text"
              name="username"
              value={tempUser.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email Address:</label>
            <input
              type="email"
              name="email"
              value={tempUser.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              name="fullName"
              value={tempUser.fullName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              name="address"
              value={tempUser.address}
              onChange={handleChange}
              required
            />
          </div>
          {!editingUser && ( // Password field only for new users
            <div className="form-group">
              <label>Password:</label>
              <input
                type="password"
                name="password"
                value={tempUser.password}
                onChange={handleChange}
                required={!editingUser}
              />
            </div>
          )}
          {editingUser && ( // Optional: New Password field for existing users
            <div className="form-group">
              <label>New Password (leave blank to keep current):</label>
              <input
                type="password"
                name="password"
                value={tempUser.password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
            </div>
          )}
          <div className="modal-actions">
            <button type="submit" className="btn-primary">
              {editingUser ? "Update User" : "Add User"}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserFormModal;
